<script>
	import Cover from './Cover.svelte'
	export let covers
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';


	const dispatch = createEventDispatcher();


	function getNew() {
	    dispatch('message', {
        type: "reload",
	      id: undefined
	    });
	  }

</script>

<div class="covers" transition:fade>
	{#each covers as cover}
	<Cover {cover} on:message />
	{/each}
</div>

<style>
	.covers {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap:  0.5rem;
		max-width: 600px;
    width: 100%;
		margin: .5rem auto;
    height: max-content
	}

	.reload {
		font-size: 3rem;
    	line-height: 1;
    	grid-column: span 3 / span 3;
    	text-align: center;
    	cursor: pointer;
    	margin: auto;
    	fill:  rgb(52, 211, 153);
	}

	@media screen and (min-width:720px) {
		.covers {

			grid-template-columns: repeat(5, 1fr);
			max-width: 1200px;

		}

		.reload {
			grid-column: span 1;
		}
	}
</style>